import clsx from 'clsx';
import {useState, useEffect} from 'react';
import Cookies from 'js-cookie'

export default function CookiesBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [acceptCookies, setAcceptCookies] = useState(false);

  const handleAcceptCookies = () => {
    setAcceptCookies(true);
    Cookies.set('acceptCookies', 'true', { expires: 15 });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowBanner(true);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const cookies = Cookies.get('acceptCookies');    
    if (cookies === 'true') {
      setAcceptCookies(true);
    }
  }, []);

  if (acceptCookies) {
    return null
  }

  return (
    <>
      {showBanner &&      
        <div className="fixed bg-main w-full bottom-0 z-50 p-10">
          <div className="flex flex-col-reverse lg:grid lg:grid-cols-4 gap-5">
            <div className="hidden lg:block"></div>
            <div className="lg:col-span-2">
              <p className="pr-20 text-white mt-edit lg:mt-0">We use cookies to improve your experience on our website. By continuing to browse our site, you accept our privacy policy and the use of these cookies. To learn more about our use of cookies, please see our privacy policy.</p>
            </div>
            <div className="flex items-center justify-center lg:justify-start mb-20 lg:mb-0">
              <button 
                className={clsx(
                  'text-white hover:text-main',
                  '!border !border-whitex px-10 py-2 hover:!bg-whitex'
                )}
                onClick={handleAcceptCookies}
              >
                Accept cookies
              </button>
            </div>
          </div>
        </div>
      }
    </>
  );
}